module.exports = __webpack_public_path__ + "img/leon.cfa1d78e.png";